import { useState, useEffect, useCallback } from 'react';
import copyToClipboard from 'copy-to-clipboard';

/**
 * @param {string} text
 * @param {number} timeout default to 2000ms
 */
const useClipBoard = (text, timeout = 2000) => {
  const [hasCopied, setHasCopied] = useState(false);

  useEffect(
    () => {
      let timeoutId;

      if (hasCopied) {
        timeoutId = setTimeout(() => {
          setHasCopied(false);
        }, timeout);
      }

      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    },
    [hasCopied, timeout],
  );

  const copy = useCallback(
    () => {
      if (hasCopied) return;

      copyToClipboard(text);
      setHasCopied(true);
    },
    [hasCopied, text],
  );

  return { copy, hasCopied };
};

export default useClipBoard;
